import {
  collection,
  addDoc,
  getDoc,
  doc,
  serverTimestamp,
  arrayUnion,
  arrayRemove,
  updateDoc,
  query,
  where,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import { db, auth } from "../FireStore";
import { updateUser } from "./user";
import { updateQuoteStateById, removeQuoteById } from "../companySlice";
import { store } from "../store";

export async function createQuote(quoteData) {
  if (quoteData.companyId) {
    // Use addDoc to add a new document with an auto-generated ID
    const quoteRef = await addDoc(collection(db, "quotes"), {
      ...quoteData,
      companyId: quoteData.companyId,
      status: "pending",
      createdAt: serverTimestamp(),
    });

    // Return a message with the generated document ID
    return quoteRef.id;
  } else {
    throw new Error("Missing company ID. Cannot create quote.");
  }
}

export async function getQuotesByCompanyId(companyId) {
  // Create a reference to the quotes collection
  const quotesCollectionRef = collection(db, "quotes");

  // Create a query against the collection where companyId matches
  const q = query(quotesCollectionRef, where("companyId", "==", companyId));

  // Execute the query and get the documents
  const querySnapshot = await getDocs(q);

  // Extract and return the data from the documents
  const quotes = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return quotes;
}

export async function getQuoteById(quoteId) {
  // Create a reference to the quotes collection
  const quoteDocRef = doc(db, "quotes", quoteId);
  const quoteDocSnapshot = await getDoc(quoteDocRef);

  if (quoteDocSnapshot.exists()) {
    const quoteData = quoteDocSnapshot.data();
    return quoteData;
  } else {
    console.log(`No quote found for ${quoteId}`);
    return null;
  }
}

export async function submitQuoteById(quoteId, updatedData) {
  const newData = { ...updatedData, status: "completed" };
  // if (updatedData.data) {
  newData.status = "completed";
  // }

  try {
    // Create a reference to the quotes collection
    const quoteDocRef = doc(db, "quotes", quoteId);

    // Update the document with the provided data
    await updateDoc(quoteDocRef, newData);
  } catch (error) {
    console.error(`Error updating quote with ID ${quoteId}:`, error);
  }
}

// updateQuoteById
export async function updateQuoteById(quoteId, updatedData) {
  try {
    // Create a reference to the quotes collection
    const quoteDocRef = doc(db, "quotes", quoteId);

    console.log("updatedData: ", updatedData);
    // Update the document with the provided data
    await updateDoc(quoteDocRef, updatedData);

    //update redux store
    store.dispatch(updateQuoteStateById({ quoteId, updatedData }));
  } catch (error) {
    console.error(`Error updating quote with ID ${quoteId}:`, error);
  }
}

// deleteQuoteById
export async function deleteQuoteById(quoteId) {
  try {
    // Create a reference to the quotes collection
    const quoteDocRef = doc(db, "quotes", quoteId);

    // Delete the document
    await deleteDoc(quoteDocRef);

    //update redux store
    store.dispatch(removeQuoteById(quoteId));
  } catch (error) {
    console.error(`Error deleting quote with ID ${quoteId}:`, error);
  }
}
